module.exports = __webpack_public_path__ + "img/sensotex_xl.457005a.webp";